import { useState, useEffect } from 'react';


export function useUser() {
  const [user, setUser] = useState<any>(null);
  const [checkingLogin, setCheckingLogin] = useState(true);

  useEffect(() => {
    fetch(`/api/auth/me`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        if (data.uuid) setUser(data);
        setCheckingLogin(false);
      })
      .catch(() => setCheckingLogin(false));
  }, []);

  const logout = async () => {
    await fetch(`/api/auth/logout`, { method: 'POST', credentials: 'include' });
    setUser(null);
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  };

  // 로그인
  const handleLogin = async (enteredId: string) => {
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ enteredId }),
      });
      const data = await res.json();
      if (data.success) {
        setUser({ uuid: data.uuid });
        return { success: true, uuid: data.uuid };
      } else {
        return { success: false, error: data.error || '로그인 실패' };
      }
    } catch (err) {
      return { success: false, error: '서버 오류' };
    }
  };

  // 회원가입 요청
  const handleJoin = async (enteredId: string, joinNick: string) => {
    try {
      const res = await fetch('/api/auth/join-request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: enteredId, nickname: joinNick })
      });
      const data = await res.json();
      if (data.success) {
        return { success: true, msg: '가입 요청이 접수되었습니다. 관리자의 승인을 기다려주세요.' };
      } else {
        return { success: false, error: data.error || '가입 요청 실패' };
      }
    } catch {
      return { success: false, error: '서버 오류' };
    }
  };

  return { user, setUser, checkingLogin, logout, handleLogin, handleJoin };
}

// ProfileModal 전용 커스텀 훅 (상태/핸들러 완전 분리)
/**
 * 닉네임·프로필 이미지를 바꾸던 훅(useProfileModal)은 걷어냈다.
 * 닉은 인게임 닉을 따라가고, 얼굴은 게임 화면에서 잘라 올린다.
 */
